<template>
    <div class="viewLoad component-holder">
        <div class="viewLoad_header">
            <div class="title">
	            <div class="text">View load</div>
	            <div class="block_id">
		            Load: {{ dataVal.id }}
	            </div>
            </div>
            <div class="close" @click="onCloseViewLoad">
	            <svg-sprite icon-id="close" width="20" height="20"></svg-sprite>
            </div>
        </div>
        <div class="viewLoad_content">

            <div class="viewLoad_block">
                <div class="left">
                    <div class="left_title">Load info</div>
                    <div class="viewText viewText1">
                        <div class="label">Broker name</div>
                        <div class="text">{{ dataVal['broker_name'] }}</div>
                    </div>
                    <div class="viewText viewText2">
                        <div class="label">Broker load</div>
                        <div class="text">{{ dataVal['broker_number'] }}</div>
                    </div>
                    <div class="viewText viewText3">
                        <div class="label">Factoring company</div>
                        <div class="text">{{ dataVal['factoring_name'] }}</div>
                    </div>

                    <div class="viewText cell viewText4">
                        <div class="label">Gross</div>
                        <div class="text">{{ dataVal.gross }}</div>
                    </div>
                    <div class="viewText cell viewText5">
                        <div class="label">Amount</div>
                        <div class="text">
                            <input :disabled="!permissions['9']" class="amountInput" type="number" v-model="amount_factoring">
                        </div>
                    </div>
                    <div class="viewText cell withoutMargin viewText6">
                        <div class="label">Debt</div>
                        <div class="text">{{ dataVal.debt }}</div>
                    </div>

                    <div class="viewText cellLong viewText7">
                        <div class="label">Processed date</div>
                        <div class="text">{{ dataVal['processed_date'] }}</div>
                    </div>
                    <div class="viewText cellSmall viewText8">
                        <div class="label">Age (days)</div>
                        <div class="text" :style="getStatusAge">{{ dataVal.age }}</div>
                    </div>
                    <div class="viewText viewText9">
                        <div class="label">Load status</div>
                        <v-select
                            :items="items"
                            v-model="status"
                            :disabled="!permissions['9']"
                            dense
                        ></v-select>
                    </div>
                </div>
                <div class="right">
	                <div class="cardWrap">
		                <div class="cardWrap_head">
			                <div class="cardWrap_left">
				                <div class="name">Actions</div>
			                </div>
			                <div class="cardWrap_right">
				                <v-btn
						                @click="onAddAction" :disabled="!permissions['9']"
						                depressed class="mainBtn mainBtn-text"
				                >
					                <span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
					                <span class="btnText">Add action</span>
				                </v-btn>
			                </div>
		                </div>
		                <div class="cardWrap_main">
			                <main-table
					                padding="0 0 10px"
					                flag="shortPaymentsActions"
					                :headers="getHeaders"
					                :listItems="shortPaymentsActions"
					                :filtersList="{}"
					                :is-hide-header="false"
					                :items-per-page-amount="10"
					                :pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
					                @updateClickButton="onClickButton"
			                ></main-table>
		                </div>
	                </div>
                </div>
            </div>
        </div>

	    <button-groups
			    @updateBtnClose="onCloseViewLoad"
			    :preloader="false"
			    @updateSave="onSave"
	    ></button-groups>

	    <actions-drawer
			    v-if="isDrawer"
			    :dataActions="dataVal"
			    :editAction="editAction"
			    :isDrawer="isDrawer"
			    @closeDrawer="onDrawer"
			    :dataSort="dataSort"
	    ></actions-drawer>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

const ActionsDrawer = () => import('@/components/Accounting/ShortPayments/ActionDrawer/ActionDrawer');
// import ActionsTable from "@/components/Accounting/ShortPayments/ActionsTable/ActionsTable";
import { viewLoadActionsTable } from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/defaultHeaders";
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups.vue";

export default {
	name: "ViewLoad",
	components: {
		ButtonGroups,
		ActionsDrawer,
	},
	props: {
		dataVal: Object,
		actions: Object,
		dataSort: Object,
		permissions: Object
	},
	computed: {
		...mapGetters([
			'shortPaymentsActions',
		]),
		getHeaders() {
			return viewLoadActionsTable;
		},
		getStatusAge() {
			const { age } = this.dataVal;

			if (age >= 30 && age <= 60) return 'color: rgba(244, 151, 65);';
			if (age > 60) return 'color: #e91e63;';
			return '';
		}
	},
	data: () => ({
		items: [ 'Waiting for payment', 'Complete', 'Bond', 'Inactive customer', 'Processed by customer' ],
		status: '',
		amount_factoring: 0,
		isDrawer: null,
		editAction: null
	}),
	methods: {
		...mapActions([ 'onSaveShortPaymentLoad', 'onShortPaymentsList' ]),
		onCloseViewLoad() {
			this.$emit('updateCloseViewLoad');
		},
		onDrawer() {
			this.editAction = null;
			this.isDrawer = false;
		},

		onClickButton(values) {
			const { key, item } = values;

			if (key === 'delete1') this.deleteAction(item);
			if (key === 'edit1') this.onEditActions(item);
		},

		onEditActions(values) {
			this.editAction = values;
			this.isDrawer = true;
		},
		deleteAction(value) {
			this.$emit('actionDelete', value);
		},
		onAddAction() {
			this.isDrawer = true;
		},
		async onSave() {
			const values = {
				id: this.dataVal.id,
				amount_factoring: +this.amount_factoring,
				status: this.status
			};

			await this.onSaveShortPaymentLoad(values);
			await this.onShortPaymentsList();
			this.onCloseViewLoad();
		}
	},
	mounted() {
		this.amount_factoring = this.dataVal['amount_factoring'];
		this.status = this.dataVal['status'];
	}
};
</script>

<style scoped lang="scss">
 @import "ViewLoad";

 @import "@/assets/style/components/cardWrap";
</style>
